import React, { useEffect, useState } from 'react';
import { Navbar } from './Components/NavBar/Navbar';
import { Welcome } from './Components/Welcome/Welcome';
import { StoryBackground } from './Components/Welcome/StoryBackground';
import './App.scss'

import { handleOnMove, updateLastMousePosition, originPosition } from './MouseEffects';
import { loadCourseContent } from './data/courseContent';

export interface SectionProps {
    static?: boolean;
}

function App() {
  const [contentState, setContentState] = useState<"loading" | "ready" | "error">(
    "loading"
  );

  useEffect(() => {
    const handleTouchMove = (e: TouchEvent) => handleOnMove(e);
    const handleMouseLeave = () => updateLastMousePosition(originPosition);

    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    if (!window.location.hash) {
      window.scrollTo(0, 0);
    }

    window.addEventListener('touchmove', handleTouchMove);
    document.body.addEventListener('mouseleave', handleMouseLeave);

    loadCourseContent()
      .then(() => setContentState("ready"))
      .catch((error) => {
        console.error(error);
        setContentState("error");
      });

    return () => {
      window.removeEventListener('touchmove', handleTouchMove);
      document.body.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  if (contentState !== "ready") {
    return (
      <div className="app scroll-story-app">
        <div className="course-content-status" role="status">
          {contentState === "loading" ? (
            "Loading course content…"
          ) : (
            <>
              Couldn’t load <code>content/course.json</code>. For local
              testing that file lives in <code>public/content/</code>.
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="app scroll-story-app">
      <StoryBackground />
      <Navbar />
      <Welcome />
    </div>
  );
}

export default App;
